import React from 'react';
import TextInfo, {
  TEXT_INFO_ALIGN,
  TEXT_INFO_DISPLAY,
  TEXT_INFO_KIND,
  TEXT_INFO_SIZE,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_COLOR,
} from '@gcloud-npm/next12.components.text-info';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import { useDispatch, useSelector, connect } from 'react-redux';
import { SLIDER_ID, types, actions as actionsUI } from '@/reducers/ui';

const MAIN_TAGGING_INFO = {
  componentProduct: 'alarmas',
  componentName: '',
  componentVariation: 'all',
  componentContent: '',
  componentePerso: '',
};

const AlarmFeature = ({ index, name, picUrl, selected }) => {
  const cssName = selected ? 'AlarmFeature selected' : 'AlarmFeature';
  const dispatch = useDispatch();
  return (
    <div className={cssName}>
      <CustomLink
        taggingInfo={{
          ...MAIN_TAGGING_INFO,
          componentName: 'customLink',
          componentContent: '',
        }}
        onClick={() => {
          // setActiveSlide(slideToGo);
          // dispatch({ type: 'patata' });
          dispatch(
            actionsUI.setActiveSlide({
              sliderId: SLIDER_ID.Prueba,
              slideIndex: index,
            })
          );
        }}
      >
        <img
          src={`${process.env.NEXT_PUBLIC_CDN}${picUrl}`}
          alt="elementos alarma incluidos"
          loading="lazy"
        />
        <TextInfo
          className="h3-carrousel centrar-txt"
          align={TEXT_INFO_ALIGN.CENTER}
          display={TEXT_INFO_DISPLAY.BLOCK}
          kind={TEXT_INFO_KIND.PARAGRAPH}
          size={TEXT_INFO_SIZE.CAPTION3}
          fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
          color={TEXT_INFO_COLOR.BLACK}
          dangerouslySetInnerHTML={{ __html: name }}
        />
      </CustomLink>
      <style jsx>
        {`
          .AlarmFeature {
            &.selected {
              img {
                border-bottom: 2.5px solid var(--color-gp--blue-a);
              }
            }
            img {
              border-bottom: 2.5px solid var(--color-gp--grey2);
              margin: auto;
              margin-bottom: 0.3rem;
              min-width: 110px;
            }
          }
          @media only screen and (max-width: 768px) {
            img {
              min-width: 94px;
            }
          }
        `}
      </style>
    </div>
  );
};

const mapStateToProps = (state) => ({
  ui: state.ui,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(AlarmFeature);
